const isPermissionApprovalInteractionResponseEvent = (event = {}) => {
  const normalizeToken = (value) => {
    return String(value || '')
      .trim()
      .toLowerCase();
  };
  const hasBooleanApprovalDecisionShape = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return false;
    }

    return typeof value?.decision === 'boolean' || typeof value?.remember === 'boolean';
  };
  const interactionType = normalizeToken(event?.interactionType || event?.payload?.interactionType || event?.response?.interactionType || '');

  if (interactionType === 'permission_approval') {
    return true;
  }

  if (hasBooleanApprovalDecisionShape(event?.response)) {
    return true;
  }

  if (hasBooleanApprovalDecisionShape(event?.payload?.response)) {
    return true;
  }

  return hasBooleanApprovalDecisionShape(event?.payload);
};

export default isPermissionApprovalInteractionResponseEvent;
